import Swal from "sweetalert2";
import { db } from "../../Firebase/firebase";

function httpGetAsync(theUrl, callback, setLoading) {
  setLoading(true);
  var xmlHttp = new XMLHttpRequest();
  xmlHttp.onreadystatechange = function () {
    if (xmlHttp.readyState === 4) {
      if (xmlHttp.status === 200) {
        callback(xmlHttp.responseText);
      } else {
        setLoading(false);
        console.log("Ocurrió un error desconocido.\n\n" + xmlHttp.responseText);
        Swal.fire({
          icon: "error",
          text: `Ha ocurrido un error, inténtalo de nuevo.
                        ${xmlHttp.responseText}`,
        });
        db.collection("errors")
          .add({
            error: xmlHttp.responseText,
            date: new Date(),
          })
          .then((docRef) => {
            console.log("Document written");
          });
      }
    }
  };
  xmlHttp.open("GET", theUrl, true); // true for asynchronous
  xmlHttp.send(null);
}

export default httpGetAsync;
